import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function FadeIn({ html, left }) {
  const ref = useRef(null);
  const controls = useAnimation();
  const [inViewRef, inView] = useInView({
    triggerOnce: false,  // Trigger animation only once
    threshold: 0.5,     // Start animation when 10% of the element is in view
  });

  // Combine ref from useInView and the element's ref
  const setRefs = (el) => {
    ref.current = el;
    inViewRef(el);
  };
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);
  const variants = {
    hidden: { opacity: 0, x: left ? -150 : 150 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <motion.div 
   
    ref={setRefs}
    variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.6,
      }}>
      {html}
    </motion.div>
  );
};


export default FadeIn;
